<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center">
              <div class="header-icon-wrap mr-3">
                <i class="fe fe-activity" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Manage Diseases</h4>
                <small style="opacity: 0.8;">{{ diagnoses.total }} disease(s) registered</small>
              </div>
            </div>
            <button class="btn btn-light btn-sm" style="border-radius: 8px; font-weight: 600;" @click="showadder = !showadder">
              <i class="fe mr-1" :class="showadder ? 'fe-x' : 'fe-plus'"></i>
              {{ showadder ? 'Close Form' : 'Disease Form' }}
            </button>
          </div>
        </div>
      </div>

      <section style="margin-top: -20px;">
        <div class="container pb-5">

          <!-- Add / Edit form -->
          <div v-show="showadder" class="card shadow-sm form-card mb-4">
            <div class="form-card-header">
              <div class="section-number">
                <i class="fe" :class="edit ? 'fe-edit-2' : 'fe-plus'" style="font-size: 13px;"></i>
              </div>
              <h6 class="mb-0 font-weight-bold text-white">{{ edit ? 'Edit Disease' : 'Add Disease' }}</h6>
            </div>
            <div class="card-body px-4 py-4">
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="register.name"
                    placeholder="Disease Name"
                  />
                </div>

                <div class="form-group col-md-6">
                  <label class="info-label d-block mb-1">Select Type</label>
                  <select
                    class="form-control"
                    v-model="register.is_primary"
                  >
                    <option value="1">Primary</option>
                    <option value="0">Secondary</option>
                  </select>
                </div>
              </div>

              <button class="btn btn-submit px-4" @click="submitForm">
                <i class="fe mr-1" :class="edit ? 'fe-save' : 'fe-send'"></i> Submit
              </button>
            </div>
          </div>

          <!-- Diseases table -->
          <div class="card shadow-sm table-card">
            <div class="d-flex align-items-center px-4 pt-4 pb-3">
              <i class="fe fe-list text-primary mr-2"></i>
              <h6 class="mb-0 font-weight-bold">Disease Registry</h6>
              <span class="badge badge-soft-info ml-2">{{ diagnoses.data ? diagnoses.data.length : 0 }}</span>
            </div>
            <div class="table-responsive">
              <table class="table align-td-middle mb-0">
                <thead class="table-head">
                  <tr>
                    <th class="table-th">Name</th>
                    <th class="table-th"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="diag in diagnoses.data" v-bind:key="diag.id" class="table-row">
                    <td class="py-3 px-4 font-weight-bold">{{ diag.name }}</td>
                    <td class="py-3 pr-4">
                      <div class="d-flex" style="gap: 6px;">
                        <button class="btn btn-sm btn-outline-info" @click="startEdit(diag)" title="Edit">
                          <i class="fe fe-edit"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-danger" @click="deleteDiagnosis(diag)" title="Delete">
                          <i class="fe fe-delete"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="!diagnoses.data || !diagnoses.data.length">
                    <td colspan="2" class="text-center py-5 text-muted">
                      <i class="fe fe-inbox" style="font-size: 2rem; opacity: 0.3;"></i>
                      <p class="mt-2 mb-0">No diseases found</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      showadder: false,
      edit: false,
      diagnoses: "",
      register: {
        name: "",
        symptoms: "",
        transmission: "",
        treatment: "",
        is_primary: "",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    getDiagnoses() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/diagnosis-agency/407465`)
        
        .then((response) => {
          this.diagnoses = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    submitForm(){
      if (this.edit == false) {
        this.AddDisease()
      } else {
        this.updateDisease()
      }
    },

    AddDisease() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .post("/api/v1/auth/diagnosis", {
          agency_id: 407465,
          name: this.register.name,
          symptoms: this.register.symptoms,
          transmission: this.register.transmission,
          treatment: this.register.treatment,
          is_primary: false,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$breadstick.notify("Disease added successfully! ", {
            position: "top-right",
          });
          this.clearIt();
          this.edit = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.$breadstick.notify("Oops! something went wrong", {
            position: "top-right",
          });
        });
    },
    clearIt() {
      this.register.name = "";
      this.register.treatment = "";
      this.register.symptoms = "";
      this.register.transmission = "";
    },

    deleteDiagnosis(diag) {
      if (confirm("Are you Sure?")) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .delete(`/api/v1/auth/diagnosis/${diag.id}`)
          .then((response) => {
            this.getDiagnoses();
            response;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    updateDisease() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.isLoading = true;
      this.axios
        .put("/api/v1/auth/diagnosis/" + this.register.id, {
          agency_id: 407465,
          is_primary: this.register.is_primary,
          name: this.register.name,
          symptoms: this.register.symptoms,
          transmission: this.register.transmission,
          treatment: this.register.treatment,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.edit = false;
          this.$breadstick.notify("Disease updated successfully! ", {
            position: "top-right",
          });
          this.clearIt();
          this.getDiagnoses();
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
          this.$breadstick.notify("Oops! something went wrong", {
            position: "top-right",
          });
        });
    },

    startEdit(diag) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.showadder = true;
      this.edit = true;
      this.register.name = diag.name;
      this.register.id = diag.id;
      this.register.is_primary = diag.is_primary;
    },
  },
  created() {
    this.getDiagnoses();
  },
};
</script>
